import React, { PureComponent } from "react";
import moment from "moment";

// function WebinarItem({
const WebinarItem = ({
  webinar: { id, webinar_title, start_date, end_date, cpd_points, status },
  checkedWebinarIds,
  webinar_ids,
}) => {
  console.log(webinar_ids);
  const is_checked = _.includes(webinar_ids, id);

  return (
    <tr>
      <td>
        {!(
          new Date(start_date) <= new Date() && new Date(end_date) >= new Date()
        ) && (
          <p>
            <input
              type="checkbox"
              className="filled-in"
              id="filled-in-box10"
              checked={is_checked}
              key={id}
            />
            <label
              for="filled-in-box10"
              onClick={() => checkedWebinarIds(id)}
            ></label>
          </p>
        )}
      </td>
      <td>
        {start_date ? moment(start_date).format("D/M/YYYY") : "Record"}
        <span>
          {start_date ? moment(start_date).format("h:mm a").toUpperCase() : ""}
        </span>
      </td>
      <td>{webinar_title}</td>
      <td>{cpd_points}</td>
      <td>{status}</td>
    </tr>
  );
};

WebinarItem.defaultProps = {};

WebinarItem.propTypes = {};

export default WebinarItem;



// WEBPACK FOOTER //
// ./src/components/Admin/ClientUrls/AddWebinars/WebinarItem.jsx